import { createBrowserRouter, Outlet } from 'react-router-dom';
import LoginPage from '../features/auth/components/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import UserPage from '../features/user/components/UserPage';
import HistoryPage from '../features/history/components/HistoryPage';
import SettingPage from '../features/setting/components/SettingPage';
import ErrorBoundary from '../components/ErrorBoundary';
import NotFoundPage from '../components/NotFoundPage';
import HomeRedirect from './HomeRedirect';
import GuestRoute from './GuestRoute';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <HomeRedirect />,
      },
      {
        path: 'login',
        element: (
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        ),
      },
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: 'user',
            element: <UserPage />,
          },
          {
            path: 'history',
            element: <HistoryPage />,
          },
          {
            path: 'setting/1honbu',
            element: <SettingPage honbu='1honbu' />,
          },
          {
            path: 'setting/2honbu',
            element: <SettingPage honbu='2honbu' />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default router;
